import * as types from "../../constants/index"
import api from "@/api"
import sensorLog from "@/utils/sensorLog"
export default {
  state: {
    giftModalShow: false,
    giftStudentSuccess: false,
    hongbaoInfo: null,
    hongbaoStudentInfo: null
  },
  actions: {
    async fetchGiftData({ dispatch, commit, rootState }, payload) {
      commit(types.FETCH_HONGBAO_DATA)
      try {
        commit(types.FETCH_HONGBAO_DATA_SUCCESSED, await api.fetchGiftData())
      } catch (error) {
        commit(types.FETCH_HONGBAO_DATA_FAILED, error)
        return Promise.reject(error)
      }
    },
    async getStudentGiftNum({ dispatch, commit, rootState }, payload) {
      commit(types.FETCH_HONGBAO_STUDENT_DATA)
      try {
        commit(
          types.FETCH_HONGBAO_STUDENT_DATA_SUCCESSED,
          await api.getStudentGiftNum(payload)
        )
      } catch (error) {
        commit(types.FETCH_HONGBAO_STUDENT_DATA_FAILED, error)
        return Promise.reject(error)
      }
    }
  },
  mutations: {
    [types.STUDENT_GIFT_MODEL_SHOW](state, payload) {
      state.giftModalShow = payload
    },
    [types.STUDENT_GIFT_SUCCESS](state, payload) {
      state.giftStudentSuccess = payload
    },
    [types.FETCH_HONGBAO_DATA](state, payload) {
      state.hongbaoInfo = null
    },
    [types.FETCH_HONGBAO_DATA_SUCCESSED](state, payload) {
      state.hongbaoInfo = payload
      sensorLog.track(
        "get_gift_data",
        types.SENSORLOG.type.SUCCESSED,
        JSON.stringify(payload)
      )
    },
    [types.FETCH_HONGBAO_DATA_FAILED](state, payload) {
      state.hongbaoInfo = null
      sensorLog.track(
        "get_gift_data",
        types.SENSORLOG.type.FAILED,
        JSON.stringify(payload)
      )
    },
    [types.FETCH_HONGBAO_STUDENT_DATA](state, payload) {
      state.hongbaoStudentInfo = null
    },
    [types.FETCH_HONGBAO_STUDENT_DATA_SUCCESSED](state, payload) {
      state.hongbaoStudentInfo = payload
      sensorLog.track(
        "get_student_gift_num",
        types.SENSORLOG.type.SUCCESSED,
        JSON.stringify(payload)
      )
    },
    [types.FETCH_HONGBAO_STUDENT_DATA_FAILED](state, payload) {
      state.hongbaoStudentInfo = null
      sensorLog.track(
        "get_student_gift_num",
        types.SENSORLOG.type.FAILED,
        JSON.stringify(payload)
      )
    }
  },
  getters: {
    giftModalShow: state => state.giftModalShow,
    giftStudentSuccess: state => state.giftStudentSuccess,
    hongbaoInfo: state => state.hongbaoInfo,
    hongbaoStudentInfo: state => state.hongbaoStudentInfo
  }
}
